import { AnimatedSection } from "@/components/AnimatedSection";

const EVERYDAY = [
  "BMW", "Mercedes-Benz", "Audi", "Volkswagen", "Ford", "Vauxhall",
  "Toyota", "Honda", "Nissan", "Hyundai", "Kia", "SEAT", "Škoda",
];

const PRESTIGE = [
  "Volvo", "Land Rover", "Jaguar", "Porsche", "Bentley",
  "Rolls-Royce", "McLaren", "Maserati", "Ferrari", "AMG",
];

/**
 * "Every Make. Every Model." marque credibility strip.
 * Two visual tiers — everyday marques + prestige & performance —
 * to signal Woodseer handles fleet hatches *and* exotics from the
 * same Poplar workshop.
 */
export function MarquesStrip() {
  return (
    <AnimatedSection>
      <section aria-labelledby="marques-heading" className="section-y-tight bg-background border-y border-border">
        <div className="mx-auto max-w-6xl px-4 md:px-6">
          <div className="max-w-2xl">
            <p className="eyebrow">Makes we work on</p>
            <h2 id="marques-heading" className="mt-3 display-lg text-foreground">
              Every make. Every model.
            </h2>
            <p className="mt-4 text-muted-foreground leading-relaxed max-w-xl">
              From your daily commuter to the car you really care about. Our technicians work on
              all makes and models — including a few you might not expect to find at an
              independent garage.
            </p>
          </div>

          <div className="mt-8">
            <p className="text-[11px] font-bold tracking-[0.22em] uppercase text-muted-foreground">
              Everyday marques
            </p>
            <ul className="mt-3 flex flex-wrap gap-2">
              {EVERYDAY.map((m) => (
                <li
                  key={m}
                  className="inline-flex items-center rounded-full border border-border bg-card px-3.5 py-1.5 text-xs font-bold text-foreground"
                >
                  {m}
                </li>
              ))}
            </ul>
          </div>

          <div className="mt-6 rounded-2xl border border-primary/20 bg-foreground/[0.04] p-5 md:p-6">
            <p className="text-[11px] font-bold tracking-[0.22em] uppercase text-primary">
              Prestige &amp; performance
            </p>
            <ul className="mt-3 flex flex-wrap gap-2">
              {PRESTIGE.map((m) => (
                <li
                  key={m}
                  className="inline-flex items-center rounded-full border border-primary/30 bg-background px-3.5 py-1.5 text-xs font-bold text-foreground"
                >
                  {m}
                </li>
              ))}
            </ul>
            <p className="mt-4 text-xs text-muted-foreground">
              Independent garage pricing, prestige-grade attention to detail. If you've been told
              an independent can't handle your car — bring it to us.
            </p>
          </div>
        </div>
      </section>
    </AnimatedSection>
  );
}
